// extracted by mini-css-extract-plugin
export default {"container":"SettingsDropdown_container__kputO","indicator":"SettingsDropdown_indicator__qz4Ty","profilePicture":"SettingsDropdown_profilePicture__XcNh8"};